import { BaseReactiveClass } from 'Classes/BaseReactiveClass';

const NAME_REGEX = /(.*)\s((\*{4})?\d{4})(\sins_\d+)?$/;

export class ModelAccountWalletBankAccount extends BaseReactiveClass {
  static TYPE_BALANCE = 'balance';
  static TYPE_BANK = 'bank';
  static ATTACHMENT_METHOD_MANUAL = 'manual';
  static ATTACHMENT_METHOD_AUTOMATED = 'automated';
  static STATUS_PENDING = 'pending';

  get isAttachmentMethodManual() {
    return this.attachment_method === ModelAccountWalletBankAccount.ATTACHMENT_METHOD_MANUAL;
  }

  get isAttachmentMethodAutomated() {
    return this.attachment_method === ModelAccountWalletBankAccount.ATTACHMENT_METHOD_AUTOMATED;
  }

  get isStatusPending() {
    return this.status === ModelAccountWalletBankAccount.STATUS_PENDING;
  }

  get clearedOfInsIdName() {
    return ModelAccountWalletBankAccount.getClearedOfInsIdName(this.name);
  }

  get isWalletFundingSource() {
    return true;
  }

  get isTypeBalance() {
    return false;
  }

  get isTypeLinkedBankAccount() {
    return true;
  }

  get maskedNumber() {
    return ModelAccountWalletBankAccount.getMaskedNumberFromBankAccountName(this.name);
  }

  get maskedNumberShort() {
    return ModelAccountWalletBankAccount.getShortMaskedNumberFromBankAccountName(this.name);
  }

  get clearedName() {
    const parsed = NAME_REGEX.exec(this.name);
    if (parsed && parsed.length >= 3) {
      return parsed[1];
    }
    return this.name;
  }

  static getClearedOfInsIdName(name) {
    return name.replace(/\sins_\d+/g, '');
  }

  static getMaskedNumberFromBankAccountName(bankAccountName) {
    const parsed = NAME_REGEX.exec(bankAccountName);
    return parsed?.[2] || bankAccountName;
  }

  static getShortMaskedNumberFromBankAccountName(bankAccountName) {
    const parsed = NAME_REGEX.exec(bankAccountName);
    if (parsed && parsed[2]) return parsed[2].slice(3, 8);
    return bankAccountName;
  }

  get institutionId() {
    if (!this.name) return null;
    const parsed = this.name.match(/ins_\d+$/);
    return parsed && parsed[0];
  }
}
